import React from 'react';
import styled from '@emotion/styled';
import { PageHeader } from '@nexus/lib-react/dist/core/PageHeader/PageHeader';
import { Page } from '@nexus/lib-react/dist/core/Page/Page';
import { Headline2 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { Paragraph2 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import SvgArrowLeft from '@nexus/lib-react/dist/core/Icon/icons/default/ArrowLeft';
import { useI18n } from '../../i18n';
import mq from '../styles/mediaQueries';

import OlxLogoContainer from './OlxLogoContainer';

const GeneralStyle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  height: 100%;
`;

const BackArrow = styled.a`
  display: inline-block;
  line-height: 0;
`;

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors['background-global-primary']};
  margin-left: -16px;
  padding-right: 16px;
  padding-top: 0;
  padding-bottom: 0;
  height: 100%;

  ${mq.desktop} {
    background-color: initial;
  }
`;

const PageHeaderDesktop = styled(PageHeader)`
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 16px 48px;
`;

export default function Template({
  desktop,
  title,
  subTitle,
  noMobileHeader,
  onBackClick,
  config,
  children,
  forceDesktop,
}) {
  const i18n = useI18n();

  if (desktop || forceDesktop) {
    return (
      <GeneralStyle>
        <Page style={{ height: '100%', paddingBottom: 0 }}>
          <PageHeaderDesktop id="page-header-desktop">
            <PageHeader.Left>
              <OlxLogoContainer homepageUrl={config?.sites?.desktop?.url} />
            </PageHeader.Left>
          </PageHeaderDesktop>
          <Section>{children}</Section>
        </Page>
      </GeneralStyle>
    );
  }

  return (
    <GeneralStyle>
      <Page style={{ height: '100%' }}>
        {!noMobileHeader && (
          <PageHeader>
            <PageHeader.Left>
              <BackArrow
                data-cy="global-back-btn"
                role="navigation"
                name="back"
                aria-label="back"
                onClick={onBackClick}
              >
                <SvgArrowLeft />
              </BackArrow>
            </PageHeader.Left>

            {title && (
              <PageHeader.Bottom>
                <Headline2 fontWeight={500} mb={12}>
                  {i18n(title)}
                </Headline2>
                {subTitle && <Paragraph2>{i18n(subTitle)}</Paragraph2>}
              </PageHeader.Bottom>
            )}
          </PageHeader>
        )}
        <Section style={{ height: '100%' }}>{children}</Section>
      </Page>
    </GeneralStyle>
  );
}
